import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ErrorBoundary } from "@/components/shared/error-boundary";
import { BrandingProvider } from "@/components/theme/branding-provider";
import { ThemeProvider } from "@/components/theme/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/auth-context";
import { initSentry } from "@/lib/sentry";
import { QueryProvider } from "@/providers/query-provider";

import "./index.css";
import "./i18n";
import App from "./App.tsx";

initSentry();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<ErrorBoundary>
			<QueryProvider>
				<ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
					<AuthProvider>
						<BrandingProvider>
							<App />
						</BrandingProvider>
					</AuthProvider>
					<Toaster />
				</ThemeProvider>
			</QueryProvider>
		</ErrorBoundary>
	</StrictMode>,
);
